<template>
  <div class="card-list-body">
    <div
      v-for="item in list"
      :key="item.cardId"
      class="list-item"
    >
      <card-text :feed="item" v-if="isTextCard(item)"/>
      <card-image :feed="item" v-else/>
    </div>
  </div>
</template>

<script>
import { isTextCard } from '@/utils/utils';

import CardImage from '@/components/Card/CardImage';
import CardText from '@/components/Card/CardText';

export default {
  name: 'ActionList',

  components: {
    CardText,
    CardImage
  },

  props: {
    list: {
      type: Array,
      default: () => ([])
    }
  },

  methods: {
    isTextCard
  }
};
</script>
